'use client';

import { c as _c } from "react/compiler-runtime";
import { TSRException } from '@/helpers/rest';
import { useTranslations } from 'next-intl';
import { useEffect } from 'react';
export const ErrorDisplay = t0 => {
  const $ = _c(11);
  const {
    err
  } = t0;
  const t = useTranslations("ErrorDisplay");
  let t1;
  let t2;
  if ($[0] !== err) {
    t1 = () => {
      console.error(err);
    };
    t2 = [err];
    $[0] = err;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  const res = err instanceof TSRException ? err.res : err;
  if (typeof res === "object" && res && "body" in res && typeof res.body === "object" && res.body && "type" in res.body && typeof res.body.type === "string") {
    let t3;
    if ($[3] !== res.body) {
      t3 = "subject" in res.body ? Array.isArray(res.body.subject) ? {
        items: res.body.subject
      } : res.body.subject : {};
      $[3] = res.body;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    const context = t3;
    let t4;
    if ($[5] !== context || $[6] !== res.body.type || $[7] !== t) {
      t4 = t(res.body.type, context);
      $[5] = context;
      $[6] = res.body.type;
      $[7] = t;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    return t4;
  }
  let t3;
  if ($[9] !== t) {
    t3 = t("unknown-error");
    $[9] = t;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};